module.exports = __webpack_public_path__ + "media/angular-engine/app/guest/register/inbox-ff903a950996991bf19bf6fe674fd19c.svg";